// extracted by mini-css-extract-plugin
export var blink = "_72-2";
export var cursor = "_72-1";
export var reactMarkdown = "_72-3";
export var streamingText = "_72-0";